// loadCSS & loadJS
export const loadCSS = require('fg-loadcss').loadCSS;

export const loadJS = (src, opts = {}) => {
	const { defer, async, cb, onError } = {
		async: true,
		defer: true,
		cb: () => null,
		onError: () => null,
		...opts,
	};
	
	const script = document.createElement('script');
	script.onload = cb;
	script.onerror = onError;
	script.src = src;
	script.async = async;
	script.defer = defer;
	
	// If this runs before any script tags are in the DOM (really only
	// possible during testing), it will fail. To address this, we check
	// for the script tag first, and register a DOMContentLoaded event
	// if it doesn't exist, so that the script loads as soon as the page does.
	const injectScript = () => {
		const firstScript = document.getElementsByTagName('script')[0];
		
		if (firstScript) {
			firstScript.parentNode.insertBefore(script, firstScript);
			return true;
		}
		
		return false;
	};
	
	if (!injectScript()) {
		document.addEventListener('DOMContentLoaded', injectScript);
	}
	
	return script;
};

export const loadScript = (src, opts = {}) => new Promise((resolve, reject) => {
	loadJS(src, {
		...opts,
		cb: resolve,
		onError: reject,
	});
});

if (!('loadCSS' in window)) {
	window.loadCSS = loadCSS;
}

if (!('loadJS' in window)) {
	window.loadJS = loadJS;
}
